module.exports = __webpack_public_path__ + "sipak_rose_hip_tea_paper_mockup.png?155c5df3eeb5bc7ab69bf2bd5548d81e";


//////////////////
// WEBPACK FOOTER
// ./src/assets/portfolio/josif_pancic/sipak_rose_hip_tea_paper_mockup.png
// module id = 79
// module chunks = 0